import { ofType } from 'redux-observable';
import { map, mergeMap, flatMap } from 'rxjs/operators';
import { from } from 'rxjs';

import {
    INITIATE
} from 'one-state-panviva/src/types';

import {
    setStatus
} from 'one-state-panviva/src/actions';

import {
    PanvivaModel
} from 'one-state-panviva/src/model';

import {
    addAction
} from 'one-state-error/src/actions';

import {
    ErrorObject
} from 'one-state-error/src/errorobject';
import {format} from 'one-util-date';

import { Disposition } from 'one-model-local';
import { InvokeFinesseProxy } from '../../subject/src/index';
import axios from 'axios';
/**
 * This Fuction will intiate screenpop via get method to
 *  backend api and returns status
 * @param context contains the settings etc..
 */

 export const enum Types {
    
    STORE_DISPOSITION_CODE = "store-disposition-code",
}

const pushToStatus = (payload: any) => setStatus(payload);
const pushToDisposition = (payload: any) => ({ type: Types.STORE_DISPOSITION_CODE, payload });


export const fetchLiveSearchEpic = (context: any) => (
    (action$: any, state$: any) => {
        const errorTime = format(new Date(), 'LT');
        const errorDate = format(new Date(), 'LL');
        const { serverone, agentId, teamName, alertnotification, log, settings: { compatible, epicendpoints, commonendpoints, servers } } = context;
        const { locations = [] } = servers;
        const { apitoken } = epicendpoints;
        const { contact_center_type, finesse_proxy_service } = compatible;
        return action$.pipe(
            ofType(INITIATE),
            // ofType(Types.PatientSet),
           
            mergeMap((action: any) => {
                /**
                 * @param dataresponse contains the patient response
                 */

                let dataresponse: PanvivaModel = action.payload;
                let data:any = {};
                let path_url:any = ""
                const getRequest = (payload: PanvivaModel) => {
                    let headers = new Headers();
                    headers.set('Authorization', 'Basic ' + apitoken?.token);
                    headers.append("Accept", "application/json");
                    
                    headers.append("Content-Type", "text/plain");
                    if(payload?.type === "live_search") {
                        data = {
                            "username": payload.panviva_id,
                            "query": payload.key,
                            "showFirstResult": true,
                            "maximizeClient": true
                        }
                        path_url = commonendpoints?.panviva_livesearch;
                    }
                    else if(payload?.type === "live_document") {
                        data = {
                            "username": payload.panviva_id,
                            "id": payload.id,
                            "location": payload.location,
                            "maximizeClient": true
                        }
                        path_url = commonendpoints?.panviva_livedocument;
                    }
                    let response;
                    if (finesse_proxy_service) {
                        response = InvokeFinesseProxy(commonendpoints?.panviva_livesearch, data, apitoken, locations, log, 'POST', alertnotification);

                    } else {
                        response = serverone.post({
                            path: path_url,
                            data: data,
                            headers: headers
                        })
                            .then((responsefound: any) => {
                                // treating as success for screenpop

                                log.debug(
                                    "ccw-gadget,panviva-livesearch",
                                    "livesearch-epic response", {
                                    responsefound
                                });
                                let result = responsefound;
                                return result;
                            })
                            .catch((responseresult: any) => {
                                //Check the Side B server receive communication
                                if (locations?.length >= 2) {
                                    const livesearchcommTwo = locations[1]?.base + commonendpoints?.panviva_livesearch;
                                    const token = 'Basic ' + apitoken?.token;
                                    const response = axios.post(`${livesearchcommTwo}`, data, {
                                        headers: {
                                            'Accept': 'application/json',
                                            'Authorization': token,
                                            'Content-Type': 'text/plain'
                                        }
                                    })
                                        .then((response: any) => {
                                            log.debug('Receive Communication SUCCESS: ', 'Agenta health check passed with status code:', response)
                                            return response;
                                        })
                                        .catch((response: any) => {
                                            if (payload) {
                                                log.debug('LiveSearch_Panviva  ', 'Response', response);
                                                let alerterror: ErrorObject = {
                                                    source: "LiveSearch_Panviva",
                                                    type: "error",
                                                    status: 400,
                                                    erroritems: [],
                                                    error_date: errorDate,
                                                    error_time: errorTime
                                                };

                                                // A brief description on how you can troubleshoot our two common errors seen here.
                                                console.error('LiveSearch_Panviva ERROR: Unable to reach the Agenta server. If cert error (\'ERR_CERT_AUTHORITY_INVALID\'), browse the request URL and accept the certificate. If \'ERR_NAME_NOT_RESOLVED\', verify connection to UPMC server environment.');
                                                return alerterror;
                                            }
                                        });
                                    return response;
                                } else {
                                    log.error(
                                        "ccw-gadget,livesearch-epic",
                                        "livesearch", {
                                        responseresult
                                    }
                                    );
                                    let result = responseresult;
                                    return result;
                                }
                            })
                    }
                    return from(response)

                }
                //Calling getRequst function here
                //the reason is we need to use pipe function.
                return getRequest(dataresponse).
                    pipe(
                        map((response: any) => response)
                    ).
                    pipe(
                        flatMap((response: any) => {
                            const actions: any = [
                                pushToStatus(response)
                            ];
                            // let disp: Disposition = { value: "" };
                            // if (contact_center_type && contact_center_type === "five9") {
                            //     let skillName = sessionStorage.getItem("skillName");
                            //     disp.meta01 = skillName;
                            // }
                            // else {
                            //     disp.meta01 = teamName;
                            // }
                            // disp.meta00 = agentId;
                            // disp.meta02 = "";
                            // disp.meta03 = "";
                            // actions.push(pushToDisposition(disp));

                            if (response?.output?.success == true) {
                                let disp: Disposition = { value: "2027" }
                                if (contact_center_type && contact_center_type === 'five9') {
                                    let agentIdValue = sessionStorage.getItem("agentName");
                                    let skillName = sessionStorage.getItem("skillName");
                                    disp.meta00 = agentIdValue;
                                    disp.meta01 = skillName;
                                    disp.dial_list_uid = state$.value.five9Interaction?.interactionId;
                                } else {
                                    disp.meta00 = agentId;
                                    disp.meta01 = teamName;
                                    disp.dial_list_uid = state$.value.choosecaller?.callId;
                                }
                                disp.meta02 = dataresponse?.key;
                                disp.meta03 = 'client';
                                actions.push(pushToDisposition(disp));
                            }
                          else if (response?.errors && response?.errors?.length > 0) {
                                let disp: Disposition = { value: "2028" }
                                if (contact_center_type && contact_center_type === 'five9') {
                                    let agentIdValue = sessionStorage.getItem("agentName");
                                    disp.meta00 = agentIdValue;
                                    disp.dial_list_uid = state$.value.five9Interaction?.interactionId;
                                } else {
                                    disp.meta00 = agentId;
                                    disp.dial_list_uid = state$.value.choosecaller?.callId;
                                }
                                disp.meta01 = teamName;
                                disp.meta02 = dataresponse?.key;
                                disp.meta03 = 'client';
                                actions.push(pushToDisposition(disp));
                                /*changes for errors will pushed to bell icon*/
                                let errorbuild: ErrorObject = {
                                    source: "Screenpop",
                                    type: "error",
                                    status: response?.status,
                                    erroritems: response?.errors,
                                    error_date: errorDate,
                                    error_time: errorTime
                                };
                                actions.push(addAction(errorbuild))
                            }
                            return actions;
                        })
                    )
            })
        )
    }
);


